import styled from 'styled-components';

export const SelectMLStyled = styled.div`
  .ant-form-item {
    /* 为了居中公共没有margin，如果需要多个margin另加className */
    margin-bottom: 10px;
  }
  .ant-form-item.no_label {
    margin-bottom: 0;
  }
  .ant-form-item-label {
    margin-right: 19px;
    font-size: 16px;
  }
  .ant-form-item-control {
    * {
      height: calc(${(props) => props.height} - 2px);
      border-radius: 0px;
    }
    div {
      background: ${(props) =>
        props.theme[props.brand].formSelect.selectBg} !important;
    }
    .ant-select-selector {
      height: calc(${(props) => props.height} - 2px) !important;
      border-radius: 0px;
    }
    .ant-select-arrow {
      top: 8px;
    }
    input {
      height: ${(props) => props.height} !important;
    }
  }
  .ant-form-item-no-colon {
    width: ${(props) => props.labelwidth};
    height: ${(props) => props.height};
    display: flex;
    justify-content: center;
    background: ${(props) => props.theme[props.brand].formSelect.singSelectBg};
    /* color: ${(props) =>
      props.theme[props.brand].formSelect.labelBorColor}; */
    font-size: 16px;
    border-radius: 0px;
  }
  .ant-select-selection-search-input {
    min-width: ${(props) => props.inputWidth};
    height: ${(props) => props.height};
    text-align: center;
    background: ${(props) => props.theme[props.brand].formSelect.selectBg};
    color: ${(props) => props.theme[props.brand].formSelect.singSelectColor};
    font-size: 16px;
    border-radius: 0px;
    border-color: ${(props) => props.theme[props.brand].formSelect.selectColor};
  }
  .ant-select:hover {
    .ant-select-selector {
      border-color: ${(props) =>
        props.theme[props.brand].formSelect.singSelectBg} !important;
    }
  }
  .ant-select-open {
    .ant-select-selector {
      box-shadow: none !important;
      border-color: ${(props) =>
        props.theme[props.brand].formSelect.singSelectBg} !important;
    }
  }
  .ant-select-focused {
    .ant-select-selector {
      box-shadow: none !important;
      border-color: ${(props) =>
        props.theme[props.brand].formSelect.singSelectBg} !important;
    }
  }
  .ant-select:focus {
    box-shadow: none !important;
  }
  .ant-select {
    .ant-select-selector {
      * {
        line-height: ${(props) => props.height} !important;
      }
    }
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
  }
  .detail_select {
    margin-bottom: 0;
    .ant-form-item-label {
      margin-right: 0;
    }
    .ant-form-item-control {
      .ant-form-item-control-input {
        div {
          background-color: ${(props) =>
            props.theme.comm.color.cffff}!important;
        }
      }
    }
    .ant-form-item-no-colon {
      text-align: left;
      width: 169px;
      font-size: 16px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
      background: ${(props) =>
        props.theme[props.brand].formSelect.singSelectBg};
      display: inline-block;
      height: ${(props) => props.height};
      color: ${(props) => props.theme[props.brand].formSelect.labelColor};
      line-height: ${(props) => props.height};
      padding-left: 13px;
      border: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
      border-right: none;
    }
    .ant-select {
      * {
        cursor: default !important;
      }
    }
    .ant-select {
      border-top: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
      border-right: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
      border-bottom: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
    }
  }
  /* 选中可编辑的样式 */
  .detail_edit {
    .ant-form-item-control {
      .ant-form-item-control-input {
        div {
          background-color: ${(props) =>
            props.theme[props.brand].formSelect.selectBgfff} !important;
        }
      }
    }
    .ant-select {
      border-bottom: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
      border-right: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
      border-top: 1px solid
        ${(props) => props.theme[props.brand].formSelect.labelBorColor} !important;
    }
    .ant-select-selector {
      border-left: none;
      border-top: none;
    }
  }
  .detail {
    .ant-form-item-control {
      .ant-form-item-control-input {
        div {
          background-color: ${(props) =>
            props.theme[props.brand].formSelect.selectBgfff} !important;
        }
      }
    }
  }
  .ant-select-selection-placeholder {
    font-size: ${(props) =>
      props.theme[props.brand].formSelect.fontSize} !important;
  }
  .ant-select-selection-item {
    color: ${(props) =>
      props.theme[props.brand].formSelect.inputColor} !important;
    font-size: ${(props) =>
      props.theme[props.brand].formSelect.fontSize} !important;
  }
  /* 类似于/cm/ml页面的data-picker样式结束 */
  .ant-select-clear {
    top: 7px;
    background-color: ${(props) =>
      props.theme[props.brand].formSelect.singSelectBg} !important;
  }
  .no_label {
    .ant-form-item-label {
      display: none;
    }
  }
  .dis-grey {
    .ant-select-selection-item {
      color: ${(props) =>
        props.theme[props.brand].formSelect.labelBorColor} !important;
    }
  }
`;
